<template>
  <div
    class="relative w-full flex items-center justify-between h-[80px] pl-5 pr-10 font-roboto rounded-[10px] bg-customBlue-100">
    <div class="flex justify-between items-center w-full">
      <div class="flex items-center justify-start mobile:gap-2 tablet:gap-3 z-50 relative top-[40px]">
        <div
          class="rounded-full p-0.5 overflow-hidden mobile:w-20 mobile:h-20 tablet:w-[100px] tablet:h-[100px] shadow-[0px_4px_10px_0px_#00000040;] bg-white">
          <img :src="imageSrc" alt="Profile Picture" class="object-cover object-top w-full h-full rounded-full" />
        </div>
        <!-- delete button  -->
        <button v-if="!showEditForm && showImageRemove && !imageSrc.includes('default')" @click="removeImage"
          type="button"
          class="transform lg:hover:scale-[1.1] active:scale-[0.98] group flex justify-center items-center mobile:w-[25px] mobile:h-[25px] tablet:w-[30px] tablet:h-[30px] cursor-pointer rounded-full duration-300 transition-all border !border-orange-100 laptop:hover:!bg-orange-100 bg-orange-100 laptop:bg-white">
          <img src="../../assets/images/trash-icon-updated.png" alt="icon"
            class="laptop:group-hover:hidden laptop:block hidden mobile:w-[15px] tablet:w-[17px] object-contain transition-all duration-300">
          <img src="../../assets/images/trash-icon-white-updated.png" alt="icon"
            class="laptop:group-hover:block laptop:hidden block mobile:w-[15px] tablet:w-[17px] object-contain transition-all duration-300">
        </button>
        <div v-if="showEditForm && !showChangePasswordForm"
          class="transform lg:hover:scale-[1.05] active:scale-[0.98] group flex justify-center items-center mobile:w-[25px] mobile:h-[25px] tablet:w-[30px] tablet:h-[30px] cursor-pointer rounded-full duration-300 transition-all border !border-[#F5B134] laptop:hover:!bg-[#F5B134] bg-[#F5B134] laptop:bg-white">
          <img src="../../assets/images/edit-profile.svg" @click="triggerFileUpload"
            class="laptop:group-hover:hidden laptop:block hidden mobile:w-[15px] tablet:w-[18px] object-contain transition-all duration-300"
            alt="icon">
          <img src="../../assets/images/camera-icon.svg" @click="triggerFileUpload"
            class="laptop:group-hover:block laptop:hidden block mobile:w-[15px] tablet:w-[18px] object-contain transition-all duration-300"
            alt="icon">
          <input type="file" accept="image/*" ref="fileInput" @change="handleFileChange" class="hidden" />
        </div>
      </div>
      <!-- Buttons -->
      <div class="flex gap-3 z-50">
        <button v-if="!showEditForm && !showChangePasswordForm" @click="openEditForm"
          class="text-sm rounded-full mobile:px-3 py-1 mr-4 CustomYellowBtn cursor-pointer !text-[#fff] lg:hover:!text-[#333]">
          Edit Profile
        </button>

        <button v-if="true && showEditForm && !showChangePasswordForm" @click="openChangePasswordForm"
          class="text-sm rounded-full mobile:px-3 py-1 CustomYellowBtn cursor-pointer !text-[#fff] lg:hover:!text-[#333]">
          Change Password
        </button>
      </div>
    </div>
  </div>
  <div v-if="!showEditForm && !showChangePasswordForm && user">
    <div class="flex justify-end mt-3 mobile:mb-8 tablet:mb-16">
    </div>
    <div class="profile-modal-content customScrollbar !max-h-[330px] largeDesktop:!max-h-[600px] overflow-auto">
      <div class="w-full flex flex-col px-2.5 gap-[10px] largeDesktop:gap-[20px] font-roboto">
        <div>
          <h4 class="m-0 text-[25px] font-medium text-gray-900">Hi, {{
            user.user.full_name }}</h4>
          <p class="m-0 text-base text-gray-500 ">{{ user.user.email }}</p>
        </div>
        <!-- <div>
          <span class="text-sm text-customYellow-100">Company</span>
          <p class="m-0 text-base text-gray-900">{{ user.user.company }}</p>
        </div>
        <div>
          <span class="text-sm text-customYellow-100">Company Address</span>
          <p class="m-0 text-base text-gray-900">{{
            user.user.company_address?.address_1 ?? '-' }}
          </p>
        </div> -->

        <form action="#">
          <div class="w-full flex flex-col gap-2">
            <div>
              <h6 class="m-0 text-base text-[#F5B134]">Phone Number</h6>
              <p class="m-0 text-base text-[#333333] ">{{ user.user.phone || '-' }}</p>
            </div>
            <div>
              <h6 class="m-0 text-base text-[#F5B134]">Referral Code</h6>
              <p class="m-0 text-base text-[#333333] ">{{ user.user.affiliate.referral_code || '-' }}</p>
            </div>
            <div>
              <h6 class="m-0 text-base text-[#F5B134]">Referral By</h6>
              <p class="m-0 text-base text-[#333333] ">{{ user.user.affiliate.referred_by || '-' }}</p>
            </div>
          </div>
        </form>
      </div>
      <div  class="mt-[10px] largeDesktop:mt-[20px] w-full px-2.5" v-if="!$helper.isEmpty(user?.user?.referral_code)">
        <div v-if="user.user.affiliate.affiliate_type != 'employee'" class="relative w-full rounded-[10px] font-roboto !border !border-customBlue-100 bg-[#EFEFEF80]">
          <span
            class="w-full h-full px-[4px] py-[9px] 2xl:px-[10px] block !border-0 outline-none !text-[14px] !text-[#666666] ">
            Use this link to invite new Affiliates to join.
          </span>
          <button id="tour-copy-url" @click="copyLinkClicked()"
            class="absolute top-0 -right-[1px] h-full w-[42px] rounded-r-md 2xl:rounded-r-lg flex items-center justify-center bg-customBlue-100 border-customBlue-100">
            <img src="../../assets/images/copy-icon.png" alt="Share Icon" class="w-4 h-4 2xl:w-6 2xl:h-6">
          </button>
        </div>
      </div>
      <div v-if="user.user.affiliate.affiliate_type != 'employee'"  class="mt-[10px] largeDesktop:mt-[20px] w-full px-2.5 font-roboto">
        <div class="bg-[#EFEFEFB2] rounded-[10px] px-2.5 py-4">
          <div class="flex justify-between items-center pb-3 !border-b-2 !border-solid !border-white">
            <img src="../../assets/images/stripe-icon.svg" alt="stripe icon" class="w-[60px]">
            <div v-if="user.user?.is_stripe_connect == 1" class="flex items-center gap-2.5">
              <p class="mb-0 font-normal font-roboto text-sm text-[#65B741]">Connected</p>
              <img src="../../assets/images/stripe-tick.svg" alt="icon" class="w-[24px] h-[24px]">
              <button @click="viewStrip()" type="button"
                class="transform lg:hover:scale-[1.1] active:scale-[0.98] transition-all duration-500 border-0 outline-0 bg-transparent rounded-full w-[30px] h-[30px] group ml-1.5">
                <img src="../../assets/images/eye-stripe.svg" alt="icon"
                  class="w-full laptop:group-hover:hidden laptop:block mobile:hidden">
                <img src="../../assets/images/eye-stripe-hover.svg" alt="icon"
                  class="w-full laptop:group-hover:block laptop:hidden mobile:block">
              </button>
            </div>
            <p v-else class="mb-0 font-normal font-roboto text-sm text-[#FE5000]">Disconnected</p>
          </div>
          <div class="pt-[15px] largeDesktop:pt-[30px]">
            <div v-if="user.user?.is_stripe_connect == 1" class="flex justify-between items-center">
              <p class="m-0 font-normal font-roboto text-sm break-words max-w-[50%] tablet:max-w-[70%] text-[#333333]">
                {{ user.user.stripe_id }}</p>
              <!-- <button @click="disconnectStrip()"
                class="text-sm font-medium h-[35px] min-w-[110px] rounded-full flex justify-center items-center transition-all duration-300 border !border-orange-100 laptop:text-orange-100 mobile:text-white laptop:bg-white laptop:hover:text-white bg-orange-100 laptop:hover:!bg-orange-100">Disconnect</button> -->
            </div>
            <button v-else @click="connectStrip()"
              class="mx-auto text-sm font-medium h-[35px] min-w-[150px] rounded-full flex justify-center items-center transition-all duration-300 border !border-[#635BFF] laptop:text-[#635BFF] mobile:text-white laptop:bg-white bg-[#635BFF] laptop:hover:text-white laptop:hover:!bg-[#635BFF]">Connect
              with stripe</button>
          </div>
        </div>

      </div>
    </div>
    <button @click="signoutClicked" type="button"
      class="py-[8px] px-[30px] font-roboto mt-4 mobile:mx-2 tablet:mx-4 text-[15px] rounded-full no-underline font-semibold CustomYellowBtn border !shadow-none lg:!border-[#E3E3E3]
      bg-gradient-to-r from-[#F1F1F1] via-[#FFFFFF] to-[#F1F1F1] text-[#333333] ">Sign
      Out</button>
  </div>

  <!-- Edit Profile Form -->
  <div v-if="showEditForm && !showChangePasswordForm">
    <form action="#" class="mobile:mt-12 tablet:mt-20">
      <div class="w-full flex flex-col gap-2 px-2.5 max-h-[300px] tablet:max-h-[none] overflow-y-auto customScrollbar">
        <div class="pt-1">
          <inputComponent label="First Name" ref="firstNameRef" v-model="first_name" name="firstName" required
            placeholder="Enter First Name" />
        </div>
        <div class="pt-1">
          <inputComponent label="Last Name" ref="lastNameRef" v-model="last_name" name="lastName" required
            placeholder="Enter Last Name" />
        </div>
        <div class="pt-1">
          <inputComponent label="Email" ref="emailRef" v-model="email" name="email" :regex="$constants.EMAIL_REGEX"
            disabled error-message="Please enter a valid email address" placeholder="Enter Email" />
        </div>
        <div class="pt-1 flex gap-2">
          <div class="w-1/2">
            <inputComponent label="Year's of Experience" ref="yearsofexperienceRef" type="number"
              v-model="years_of_experience" name="yearsofexperience" required placeholder="Enter Years Of Experience"
              class="" />
          </div>
          <div class="w-1/2">
            <inputComponent label="Phone Number" ref="phoneRef" v-model="phone" name="phone" required type="tel"
              mask="(###) ###-####" placeholder="Enter Number" error-message="Invalid phone number" />
          </div>
        </div>
        <div class="pt-2">
          <!-- <h4 class="text-lg font-medium">Select Language (Optional)</h4>
          <div class="flex flex-wrap gap-2 pt-2">
            <span v-for="lan in language" :key="lan" @click="toggleLang(lan)" :class="[
              'mobile:py-1 mobile:px-2.5 tablet:py-1.5 tablet:px-4 rounded-full mobile:text-sm tablet:text-base cursor-pointer transition',
              selectedLanguage.includes(lan.id) ? 'bg-[#7695FF] text-white' : 'bg-gray-200 text-black'
            ]">
              {{ lan.name }}
            </span>
          </div> -->
          <!-- <h4 class="text-lg font-medium mt-3">Area of Expertise:</h4>
          <div class="flex flex-wrap gap-2 pt-2">
            <span v-for="tag in tags" :key="tag" @click="toggleTag(tag)" :class="[
              'mobile:py-1 mobile:px-2.5 tablet:py-1.5 tablet:px-4 rounded-full mobile:text-sm tablet:text-base cursor-pointer transition',
              selectedTags.includes(tag.id) ? 'bg-[#BA90C6] text-white' : 'bg-gray-200 text-black'
            ]">
              {{ tag.title }}
            </span>
          </div> -->
        </div>
      </div>
      <div class="mobile:px-2 tablet:px-4 font-roboto">
        <div class="flex items-center justify-center gap-3 pt-4 border-t border-gray-200">
          <button type="button" @click="backUserClicked"
            class="mobile:py-1.5 mobile:px-5 tablet:py-2 tablet:px-[30px] text-sm rounded-[5px] CustomYellowBtn">Cancel</button>
          <button type="button" @click="updateUserClicked"
            class="mobile:py-1.5 mobile:px-2.5 tablet:py-2 tablet:px-[18px] text-sm rounded-[5px] CustomBlueBtn">Save
            Changes</button>
        </div>
      </div>
    </form>
  </div>

  <!-- Change Password Form -->
  <div v-if="showChangePasswordForm">
    <form action="#" class="mobile:mt-12 tablet:mt-20 px-2.5">
      <div class="w-full flex flex-col gap-2">

        <!-- <div>
          <label for="password" class="block mb-1 text-sm font-medium text-gray-700">Old Password: <span
              class="text-red-600">*</span></label>
          <inputComponent v-model="oldPassword" ref="oldPasswordRef" name="oldPassword" type="password" required
            :regex="$constants.PASSWORD_REGEX" errorClass="!text-customYellow-100"
            error-message="Minimum 8 characters with uppercase, number & symbol" placeholder="Enter Password"
            customClass="!text-[16px] mobile:!p-[9px] largeDesktop:!p-[11px] !rounded-[5px]" />
        </div> -->
        <div>
          <label for="confirmPhoneNumber" class="block mb-1 text-sm font-medium text-gray-700">New
            Password: <span class="text-red-600">*</span></label>
          <PasswordInput v-model="newPassword" ref="newPasswordRef" name="newPassword"
            :regex="$constants.PASSWORD_REGEX" required placeholder="Enter new password" errorClass="!text-customYellow-100"
            error-message="Minimum 8 characters with uppercase, number & symbol. Emojis and spaces are not allowed." length="20"
            customClass="!text-[16px] mobile:!py-[9px] mobile:!pl-[9px] largeDesktop:!py-[11px] largeDesktop:!pl-[11px] !rounded-[5px] mobile:!pr-[30px] largeDesktop:!pr-[35px]" />
        </div>
        <div>
          <label for="confirmPhoneNumber" class="block mb-1 text-sm font-medium text-gray-700">Confirm New
            Password: <span class="text-red-600">*</span></label>
          <inputComponent v-model="confirmPassword" ref="confirmPasswordRef" name="confirmPassword" type="password"
            required :confirmWith="newPassword" placeholder="Enter confirm password" errorClass="!text-customYellow-100"
            error-message="Passwords do not match" length="20"
            customClass="!text-[16px] mobile:!py-[9px] mobile:!pl-[9px] largeDesktop:!py-[11px] largeDesktop:!pl-[11px] !rounded-[5px] mobile:!pr-[30px] largeDesktop:!pr-[35px]" />
        </div>
        <div class="flex items-center justify-center gap-3 pt-4 border-t border-gray-200">
          <button @click="cancelModalClicked" type="button"
            class="mobile:py-1.5 mobile:px-5 tablet:py-2 tablet:px-[30px] text-sm rounded-[5px] CustomYellowBtn">Cancel</button>
          <button @click="changePasswordClick" type="button"
            class="mobile:py-1.5 mobile:px-2.5 tablet:py-2 tablet:px-[18px] text-sm rounded-[5px] CustomBlueBtn">Save
            Changes</button>
        </div>
      </div>
    </form>
  </div>

</template>

<script>
import { ref } from 'vue'
import inputComponent from '../partialComponent/inputComponent.vue';
import PasswordInput from '../partialComponent/PasswordInput.vue';
import showEyeIcon from '../../assets/images/eyeshowIcon.png';
import hideEyeIcon from '../../assets/images/eyehideIcon.png';
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  components: {
    inputComponent,
    PasswordInput
  },
  props: {
    buttonClass: {
      type: String,
      default: '',
    },
    openModal: {

    },
    bootme: {

    },
    clickedCallback: {

    },
    userObject: {

    }
  },

  data() {
    return {
      // Visibility flags
      stripeStatus: true,
      // Input values

      email: null,
      phone: null,
      first_name: null,
      last_name: null,
      years_of_experience: null,
      // oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      referal_code: '',
      referal_by: '',
      // Icons
      showEyeIcon,
      hideEyeIcon,
      imageSrc: 'https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg',
      imageFile: null,
      tags: [],
      language: [],
      selectedTags: [],
      selectedLanguage: [],
      showEditForm: false,
      showChangePasswordForm: false,
      user: JSON.parse(localStorage.getItem('user')) ?? null,

    };
  },

  computed: {
    ...mapGetters(["stripLogin", "updatedUser", "connectivityInitDetails", "stripDisconnect", "updatePasswordResponse"]),

    showImageRemove() {
      if (this.imageSrc == 'https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg') {
        return false
      } else {
        return true
      }
    }
  },

  watch: {
    updatedUser: function () {
      if (this.showEditForm) {
        toast.success("Profile has been updated successfully.")
      }
      this.showEditForm = false
      this.user.user = this.updatedUser
      localStorage.setItem('user', JSON.stringify(this.user))
      this.setUser()
    },

    openModal: function () {
      this.showEditForm = false
      this.showChangePasswordForm = false
      this.imageFile = null
      this.setUser()
    },
    bootme: function () {
      this.language = this.bootme.languages
      this.tags = this.bootme.expertise
    },

    stripDisconnect: function () {
      this.user.user.is_stripe_connect = 0
    },

    stripLogin: function () {
      if (this.stripLogin.redirect_url.length > 0) {
        window.open(this.stripLogin.redirect_url, "_blank");
      }
    },

    updatePasswordResponse: function () {
      toast.success("Password updated successfully.");
      this.showChangePasswordForm = false
      this.showEditForm = true
    },


    connectivityInitDetails: function () {
      // if (this.connectivityInitDetails.redirect_url.length > 0) {
      //   window.open(this.connectivityInitDetails.redirect_url, '_blank');
      // }
    },

  },


  methods: {
    ...mapActions(["updateUser", "removeUserImage", "stripeDsiconnect", "getConnectivityInitDetails", "stripeLoginConnect", "updatePassword"]),

    cancelModalClicked() {
      this.showChangePasswordForm = false
      this.showEditForm = true
     },
    changePasswordClick() {
            const refsToValidate = [
        // this.$refs.oldPasswordRef,
        this.$refs.newPasswordRef,
        this.$refs.confirmPasswordRef
      ];

      let firstInvalidRef = null;

      // Validate each ref
      for (const ref of refsToValidate) {
        if (ref?.validate?.()) {
          if (!firstInvalidRef) firstInvalidRef = ref;
        }
      }

      if (firstInvalidRef) {
        // Scroll to and focus the first invalid field
        firstInvalidRef.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const inputEl = firstInvalidRef.$el.querySelector('input');
        inputEl?.focus();
        return;
      }

      this.updatePassword({
        // old_pwd: this.oldPassword,
        password: this.newPassword.trim()
      })
    },
    disconnectStrip() {

      this.$dialog.show({
        title: "Are you sure you want to disconnect your Stripe account?",
        text: "Once disconnected, you will no longer receive any payouts from My Happy Home.",
        onConfirm: () => {
          this.stripeDsiconnect()
        },
      });

    },

    viewStrip() {
      this.stripeLoginConnect()
    },
    connectStrip() {
      this.getConnectivityInitDetails()

    },

    removeImage() {

      this.$dialog.show({
        title: "Remove Profile Picture",
        text: "Are you sure you want to remove your profile picture?",
        onConfirm: () => {
          this.removeUserImage({})
          // this.imageSrc = 'https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg'
        },
      });
    },
    copyLinkClicked() {
      navigator.clipboard.writeText(`${window.location.origin}/register?referal=${this.user.user.referral_code}`)
      toast.success("Link copied successfully.");
    },
    submitClicked() {

      const refsToValidate = [
        this.$refs.firstNameRef,
        this.$refs.lastNameRef,
        this.$refs.emailRef,
        this.$refs.phoneRef,
        this.$refs.yearsofexperienceRef
      ];

      let firstInvalidRef = null;

      // Validate each ref
      for (const ref of refsToValidate) {
        if (ref?.validate?.()) {
          if (!firstInvalidRef) firstInvalidRef = ref;
        }
      }

      if (firstInvalidRef) {
        // Scroll to and focus the first invalid field
        firstInvalidRef.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const inputEl = firstInvalidRef.$el.querySelector('input');
        inputEl?.focus();
        return;
      }
      this.updateCall()
    },

    updateUserClicked() {
      this.submitClicked()

    },
    updateCall() {
      let formData = new FormData()
      formData.append("first_name", this.first_name)
      formData.append("last_name", this.last_name)
      formData.append("phone", this.phone)
      formData.append("email", this.email)
      formData.append("years_of_experience", this.years_of_experience)
      formData.append("languages", JSON.stringify(this.selectedLanguage))
      formData.append("expertise", JSON.stringify(this.selectedTags))
      formData.append("timestamp", (new Date()).getTime())


      if (this.imageFile) {
        formData.append("profile_picture", this.imageFile)
      }

      this.updateUser(formData)
    },
    backUserClicked() {
      this.showEditForm = false
    },
    setUser() {
      this.user = this.userObject

      this.email = this.user.user.email ?? null
      this.phone = this.user.user.phone ?? null
      this.first_name = this.user.user.first_name ?? null
      this.last_name = this.user.user.last_name ?? null
      this.years_of_experience = this.user.user.years_of_experience ?? null
      this.imageSrc = this.user.user.profile_picture ?? 'https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg'

      this.selectedTags = (this.user.user.expertises ?? []).map(item => item.id);
      this.selectedLanguage = (this.user.user.languages ?? []).map(item => item.id);
    },
    signoutClicked() {
      if (this.clickedCallback) {
        this.clickedCallback('signout')
      }
    },
    triggerFileUpload() {
      this.$refs.fileInput.click()
    },
    handleFileChange(event) {
      this.imageFile = event.target.files[0]
      if (this.imageFile) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.imageSrc = e.target.result
        }
        reader.readAsDataURL(this.imageFile)
      }
    },
    toggleTag(tag) {
      if (this.selectedTags.includes(tag.id)) {
        this.selectedTags = this.selectedTags.filter(t => t !== tag.id)
      } else {
        this.selectedTags.push(tag.id)
      }
    },
    toggleLang(lang) {
      if (this.selectedLanguage.includes(lang.id)) {
        this.selectedLanguage = this.selectedLanguage.filter(t => t !== lang.id)
      } else {
        this.selectedLanguage.push(lang.id)
      }
    },
    openEditForm() {
      this.showEditForm = true
    },
    openChangePasswordForm() {
      this.showChangePasswordForm = true
      // this.oldPassword = ""
      this.newPassword = ""
      this.confirmPassword = ""
    }
  },

};
</script>
